import React, { useState } from 'react';
import { translate, Trans } from 'react-i18next';
import { func } from 'prop-types';

import { Button } from '@snapask/common-components';

import LineInput from '@dragonfruit/components/fields/LineInput';

import Validator from '@dragonfruit/utils/validator';

import styles from './PhoneConfirmation.scss';

function PhoneConfirmation({
  t,
  clickConfirmCode,
  resetStage,
  onClickResendConfirmationCode,
}) {
  const [{ code, codeEmpty, codeTouched }, setCodeData] = useState({
    code: '',
    codeEmpty: true,
    codeTouched: false,
  });

  const validateConfirmationCode = () => {
    const validate = new Validator(code).isEmpty();

    setCodeData(prev => ({
      ...prev,
      codeTouched: true,
      codeEmpty: validate.haveError(),
    }));
  };

  const onChangeConfirmationCode = value => {
    setCodeData(prev => ({
      ...prev,
      code: value,
    }));
  };

  const onClickConfirmCode = () => clickConfirmCode(code);

  const onClickChangeNumber = evt => {
    evt.preventDefault();
    resetStage();
  };

  return (
    <div className={styles.codeConfirmation}>
      <p className={styles.helper}>
        <Trans i18nKey="account.updatePhoneSent">
          We've sent a verification code to your number. Please enter the
          4-digit code.
          <a onClick={onClickResendConfirmationCode}> resent code! </a>
        </Trans>
      </p>
      <div className={styles.field}>
        <LineInput
          floatingLabelText={t('account.codeLabel')}
          onChange={onChangeConfirmationCode}
          onBlur={validateConfirmationCode}
          errorText={codeEmpty && codeTouched && t('error:error.fieldEmpty')}
        />
      </div>
      <div className={styles.btnContainer}>
        <Button
          text={t('account.codeSubmitCta')}
          onClick={onClickConfirmCode}
          disabled={!code}
          primary
        />
        <a onClick={onClickChangeNumber}>
          <h6>{t('account.changeNumberCta')}</h6>
        </a>
      </div>
    </div>
  );
}

PhoneConfirmation.propTypes = {
  clickConfirmCode: func.isRequired,
  resetStage: func.isRequired,
  t: func.isRequired,
  onClickResendConfirmationCode: func.isRequired,
};

export default translate(['account', 'error'])(PhoneConfirmation);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileVerify/components/PhoneConfirmation/PhoneConfirmation.jsx